import { fetch } from '@atlassian/eoc-fetch';

import { generateLogParams, postProcessLogsSearch } from '../../../common/utils';
import type { LogsRequestParams, LogsResponseType } from '../../../common/utils/types';

export const fetchLogs = async (params: LogsRequestParams): Promise<LogsResponseType> => {
	const urlParams = generateLogParams(params);

	return fetch<LogsResponseType>('/v1/logs/search?' + urlParams.toString()).then((response) =>
		postProcessLogsSearch(urlParams, response),
	);
};
